import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indexSignatureToArray',
    pure: false,
    standalone: true
})
export class IndexSignatureToArrayPipe implements PipeTransform {
  transform<T>(
    value: { [key: string]: T } | undefined,
    ...args: unknown[]
  ): { id: string; value: T }[] {
    if (!value) {
      return [];
    }
    return Object.keys(value)
      .filter((k) => value[k])
      .map((k) => ({ id: k, value: value[k] }));
  }
}
